module.exports = __webpack_public_path__ + "images/category_lp/smartphone/assessment_achievements/2_600d3220b0556db7baf6560a63df1327.jpg";